// extracted by mini-css-extract-plugin
module.exports = {"title":"TdFormCapacity_title__2cO60","item":"TdFormCapacity_item__1KHw9","input":"TdFormCapacity_input__1LGi6"};